import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { EditTrainingGoalPage } from './edit-training-goal-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EditTrainingGoalPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class EditTrainingGoalPageModule { }
